import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/Layout'
import Tenants from '@/views/Tenants'
import Apps from '@/views/Apps'
import Login from '@/views/Login'
import Commissions from '@/views/Commissions'
import Settlements from '@/views/Settlements'
import Users from '@/views/Users'
import Roles from '@/views/Roles'
import Permissions from '@/views/Permissions'
import Flushs from '@/views/Flushs'
import Backups from '@/views/Backups'
import SysLogs from '@/views/SysLogs'
import Keywords from '@/views/Keywords'
import Settings from '@/views/Settings'
import Menus from '@/views/Menus.vue'
import CommissionSetting from '@/views/CommissionSetting.vue'
import Sections from '@/views/Sections.vue'
import Partners from '@/views/Partners.vue'
import Dashboard from '@/views/Dashboard.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/admin',
      name: 'Layout',
      component: Layout,
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/tenants',
          name: 'Tenants',
          component: Tenants
        },
        {
          path: '/menus',
          name: 'Menus',
          component: Menus
        },
        {
          path: '/apps',
          name: 'Apps',
          component: Apps
        },
        {
          path: '/commissions',
          name: 'Commissions',
          component: Commissions
        },
        {
          path: '/settlements',
          name: 'Settlements',
          component: Settlements
        },
        {
          path: '/users',
          name: 'Users',
          component: Users
        },
        {
          path: '/roles',
          name: 'Roles',
          component: Roles
        },
        {
          path: '/permissions',
          name: 'Permissions',
          component: Permissions
        },
        {
          path: '/flushs',
          name: 'Flushs',
          component: Flushs
        },
        {
          path: '/backups',
          name: 'Backups',
          component: Backups
        },
        {
          path: '/system_logs',
          name: 'SysLogs',
          component: SysLogs
        },
        {
          path: '/black_words',
          name: 'Keywords',
          component: Keywords
        },
        {
          path: '/settings',
          name: 'Settings',
          component: Settings
        },
        {
          path: '/commission_setting',
          name: 'CommissionSetting',
          component: CommissionSetting
        },
        {
          path: '/sections',
          name: 'Sections',
          component: Sections
        },
        {
          path: '/partners',
          name: 'Partners',
          component: Partners
        }
      ]
    }
  ]
})
